<template>
  <b-form inline @submit.prevent="$emit('refresh')">
    <label class="d-none d-block col-12 mb-0 pb-0 pl-lg-2">{{label ? label : 'Filtros'}} </label>
    <b-input-group class="col-sm-12 col-md">
      <b-input :value="value" variant="dark" @input="onInputHandle"></b-input>
      <b-input-group-addon v-if="!!value" append>
        <b-button @click="reset" variant="danger" class="px-2" pressed>
          X
        </b-button>
      </b-input-group-addon>
      <b-input-group-addon append>
        <b-btn type="submit" variant="light">
          <b-icon icon="search" />
          <span class="d-none d-sm-inline ml-1">Buscar</span>
        </b-btn>
      </b-input-group-addon>
    </b-input-group>
    <b-row align-h="end">
      <b-input-group class="col-sm-12 col-md">
        <slot></slot>
      </b-input-group>
    </b-row>
  </b-form>
</template>

<script>
export default {
  props: ["value", "label"],
  methods: {
    onInputHandle($evt) {
      this.$emit("input", $evt);
    },
    reset() {
      this.$emit("input", "");
      this.$emit("refresh");
    },
  },
};
</script>
